// extracted by mini-css-extract-plugin
export var chip = "_3j-0";
export var filterDropdown = "_3j-5";
export var filterItem = "_3j-6";
export var icon = "_3j-1";
export var removeButton = "_3j-3";
export var removeIcon = "_3j-4";
export var separator = "_3j-2";